<template>
    <div class="mvt-chart">
        <canvas ref="canvas"></canvas>
    </div>
</template>
<script src="./mvt-chart.js"></script>

<style lang="scss">
@use "./mvt-chart.scss" as *;
</style>